import script from "./ColumnsDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnsDropdown.vue?vue&type=script&setup=true&lang=js"

import "./ColumnsDropdown.vue?vue&type=style&index=0&id=48f45d92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f45d92"]])

export default __exports__